import { SagaIterator } from 'redux-saga'
import { put, call, takeLatest, fork } from 'redux-saga/effects'
import {
  ADD_PATIENT_PRESCRIPTION,
  DELETE_PATIENT_PRESCRIPTION,
  GET_PATIENT_PRESCRIPTIONS,
} from './actionTypes'
import {
  addPatientPrescriptionData,
  deletePatientPrescriptionData,
  getPatientPrescriptionsData,
} from './api'
import { PatientPrescription } from './types'
import {
  addPatientPrescriptions,
  errorPatientPrescription,
  getPatientPrescriptions,
  successPatientPrescription,
} from './patientPrescriptionReducer'

type Action = {
  type: string
  payload: string
}

export function* handleGetPatientPrescriptionsData(
  actions: Action
): SagaIterator<void> {
  try {
    const response = yield call(getPatientPrescriptionsData, actions.payload)
    const { data } = response
    let unmodifiedData = data.prescriptions
    let newData: PatientPrescription = {
      key: actions.payload,
      prescriptions: unmodifiedData,
    }
    yield put(addPatientPrescriptions(newData))
  } catch (error: any) {
    yield put(errorPatientPrescription(error.response.data.message))
  }
}

type DeleteAction = {
  type: string
  payload: {
    patientKey: string
    prescriptionId: string
  }
}

export function* handleDeletePatientPrescriptionData(
  actions: DeleteAction
): SagaIterator<void> {
  try {
    const response = yield call(
      deletePatientPrescriptionData,
      actions.payload.prescriptionId
    )
    yield put(getPatientPrescriptions(actions.payload.patientKey))
    const { data } = response
    yield put(successPatientPrescription(data.message))
  } catch (error: any) {
    yield put(errorPatientPrescription(error.response.data.message))
  }
}

type PostAction = {
  type: string
  payload: {
    patientKey: string
    prescriptionText: string
  }
}

export function* handleAddpatientPrescriptionData(
  actions: PostAction
): SagaIterator<void> {
  try {
    const response = yield call(
      addPatientPrescriptionData,
      actions.payload.patientKey,
      actions.payload.prescriptionText
    )
    const { data } = response
    yield put(getPatientPrescriptions(actions.payload.patientKey))
    yield put(successPatientPrescription(data.message))
  } catch (error: any) {
    yield put(errorPatientPrescription(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_PATIENT_PRESCRIPTIONS, handleGetPatientPrescriptionsData)
  yield takeLatest(ADD_PATIENT_PRESCRIPTION, handleAddpatientPrescriptionData)
  yield takeLatest(
    DELETE_PATIENT_PRESCRIPTION,
    handleDeletePatientPrescriptionData
  )
}

export const patientPrescriptionSaga = [fork(watcherSaga)]
